import { makeStyles } from '@material-ui/core'
import theme from 'theme'

const styles = makeStyles(() => ({
  label: {
    fontSize: theme.typography.h5.fontSize,
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    gap: theme.spacing(2),
  },
  subLabel: {
    fontSize: theme.typography.h6.fontSize,
    color: theme.palette.primary.main,
    gap: theme.spacing(2),
    marginLeft: theme.spacing(1),
  },
  input: {
    backgroundColor: theme.palette.white,
  },
  menuItem: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordWrap: 'break-word',
  },
}))

export default styles
